import {
  FormsConfigControllerGetFormConfigs200Response,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_FORMS_CONFIG } from "../domain";

import { formsConfigApi } from "@api/services";
import { DEFAULT_PAGE_SIZE, TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";


export const ACTION_GET_FORMS_CONFIGS = "GET_FORMS_CONFIGS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type GetFormConfigParams = {
  name?: string | undefined;
  code?: string | undefined;
  search?: string | null | undefined;
  orderBy?: string | null | undefined;
  orderDirection?: string | null | undefined;
  pageNumber?: number | undefined;
  pageSize?: number | undefined;
};

const fetchFormsConfigs = async (
  params?: GetFormConfigParams,
): Promise<FormsConfigControllerGetFormConfigs200Response> => {
  const response = await formsConfigApi.formsConfigControllerGetFormConfigs(
    params?.name,
    params?.code,
    params?.search,
    params?.orderBy,
    params?.orderDirection,
    params?.pageNumber ?? 0,
    params?.pageSize ?? DEFAULT_PAGE_SIZE,
  );

  return response.data;
};

export const useGetFormsConfigs = (
  user: UserProfileDto | null,
  params?: GetFormConfigParams,
): {
  formsConfigs: FormsConfigControllerGetFormConfigs200Response | undefined;
  formsConfigEnabled: boolean;
  isLoadingFormsConfigs: boolean;
  isFetchingFormsConfigs: boolean;
  isSuccessFormsConfigs: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { data, isLoading, isFetching, isSuccess } = useQuery<
    FormsConfigControllerGetFormConfigs200Response,
    Error
  >({
    queryKey: [DOMAIN_FORMS_CONFIG, ACTION_GET_FORMS_CONFIGS],
    queryFn: () => fetchFormsConfigs(params),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    formsConfigs: data,
    formsConfigEnabled: enabled,
    isLoadingFormsConfigs: isLoading,
    isFetchingFormsConfigs: isFetching,
    isSuccessFormsConfigs: isSuccess,
  };
};
